
import {$Add} from './Add';
import {$GetSprite} from './GetSprite';
import {$Replace} from './Replace';

export const $CacheSprite = {$Add, $GetSprite, $Replace};